import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import {
  Card,
  Button,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Pagination,
  PaginationItem,
  PaginationLink,
  Collapse,
  Row,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { isEmpty, map } from "lodash";
import axios from "../../axios"
import numeral from "numeral";
// RangeSlider
import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";
import '../../NumberInput.css'
import { makeStyles } from '@material-ui/core/styles';
import  Spinner  from 'react-spinkit'
import Backdrop from '@material-ui/core/Backdrop';

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//Import data
import { discountData, productsData, colorData } from "../../common/data";

//Import actions
import { getProducts as onGetProducts } from "../../store/e-commerce/actions";

//redux
import { useSelector, useDispatch } from "react-redux"
const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const EcommerceProducts = props => {
  const dispatch = useDispatch()
  const { products } = useSelector(state => ({
    products: state.ecommerce.products,
  }))
  // eslint-disable-next-line no-unused-vars


  const { history } = props

  const [isOpen, setIsOpen] = useState(false);
const [isopen1, setisopen1] = useState(false)
const [isopen2, setisopen2] = useState(true)
const [Purchasesavess, setPurchasesavess] = useState(false)
const [dailoa1, setdailoa1] = useState(false)
const classes = useStyles();
const [Isopen12, setIsopen12] = useState(false)
const toggle1 = () => 

setisopen1(!isopen1);
const toggle23 = () => setisopen2(!isopen2);
const toggle12 = () => setIsopen12(!Isopen12);

  const [isFilterSizesOpen, setIsFilterSizesOpen] = useState(true);

  const filtersizestoggle = () => setIsFilterSizesOpen(!isFilterSizesOpen);

  const [isFilterProductColorOpen, setIsFilterColorsOpen] = useState(true);

  const filtercolorstoggle = () => setIsFilterColorsOpen(!isFilterProductColorOpen);

  const [isFilterProductRatingOpen, setIsFilterRatingsOpen] = useState(true);

  const filterratingtoggle = () => setIsFilterRatingsOpen(!isFilterProductRatingOpen);

  const [isFilterProductDiscountOpen, setIsFilterDiscountOpen] = useState(false);

  const filterdiscountstoggle = () => setIsFilterDiscountOpen(!isFilterProductDiscountOpen);

  const [productList, setProductList] = useState([]);
  const [tokent, settokent] = useState('Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ')
  const [potodaycollection, setpotodaycollection] = useState([])
  const [sotodaycollection, setsotodaycollection] = useState([])
  const [pomonthcollection, setpomonthcollection] = useState([])
  const [somonthcollection, setsomonthcollection] = useState([])
  const [purchaseinvoicecollections, setpurchaseinvoicecollections] = useState([])
  const [salesinvoicecollections, setsalesinvoicecollections] = useState([])
  // eslint-disable-next-line no-unused-vars
  const [discountDataList, setDiscountDataList] = useState([]);
const [productmaincategory, setproductmaincategory] = useState([])
  const [filters, setFilters] = useState({
    discount: [],
    color: [],
    price: { min: 0, max: 500 },
  });
  const [page, setPage] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [totalPage, setTotalPage] = useState(1);

  useEffect(() => {
    setProductList(products);
    setDiscountDataList(discountData);
  }, [products, discountData]);

  useEffect(() => {
    dispatch(onGetProducts())
  }, [dispatch])

  useEffect(() => {
    if (!isEmpty(products)) setProductList(products);
  }, [products]);

 const [allproductslists, setallproductslists] = useState([])
 var imageDefault = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAANlBMVEX///+/v7+8vLzKysr8/Pzg4ODFxcXb29vT09Pj4+P4+PjBwcH6+vry8vLY2NjIyMjs7Ozo6Oia8u11AAAEdUlEQVR4nO2d65bqIAxGp/Smrb34/i971KqlEC7FGuJZ3/7dKewJBgK4/PsDAAAAAAAAAAAAAAAA4KUam5+i3m94UsUPoVoYwlA6MIShfGAIQ/nAEIbyOcBQSeNww9NZGOXBhuq8+w1fxugfDG1gmB0YBoFhdmAYBIbZgWEQGGYHhkFgmB0YBoFhdmAYBIbZyWB4qVI6mgyv4WUeH7u007lL7vFeWA3n8rUFrZqWK5KchnWvPapOTGFkNDQPOJrhk45Hw2d4Ns+oVPlRz2NhMxyawkTtv2OWAJvhSBwzfjBO2+g/5TLs7BDeSF4eDP0Y+yiX4UydFKtT4pRxa3SKTcVchtQgLYrobhq0Kj7+XIb0aX+fZtipHfH/ScPlZZG5Jq9hk2RYP96lTnFPcxnWpGF52d2eNrPGPc5lOJC5NDrl65Sv1fs16nEuw8v20sdCP+9uTh8NZVSuYVvTnKlBmjAdaqu/uH8Qm2FVWuNUJYSwOu3tLV9tcelNw5SF9yZjRaVixvpwbrZRTKnyuyKysRXOGn/QBqpK25QzptVm9598eyfqXDaPnah+GlNmwr/aGOcqYl3DvJtYzXU7jvU1bbVmVdExE+pP7Qjb6TiiOBFmOPuyD7XyC+djWYadGt2KxE5PzMpWluHtXc6KQZ/rNYK5RpThfWXnrGzp6iRcQ0ky7KbHK+iBup3rtQZD6wZJhq+9HDIsri89BBsUZPguIal0Y871K6ECRY6hXkFaimQeXQjVUHIMNwWkuVax5/q1xcC6Rozh0G+7vYmidaqzCaJ/whBjaEZJr608Y7QIHvBIMbR3/dfB55jr3/hrKCGGxMHN+vmi53rtSW+uEWLYUj1/dsY1169tetc1MgwHaw9HU3TN9Svec0huw4os6CZHcO7dcc/163O+XMNteC0JRfdk0Aby6BNfDcW9i1EquzedI4R36vAYLfy5htnwtnBRvaHo/SZxjN8Nz7UO5ltf97WnMgbqHCfhRbmHKa/hdXl2qxjzQQsaunMNr+FzUlD62W8bORD9TM4gshpe3xVg+Z7BonJlmN55mMhpWGkV4GughtacsbgvLnAa6hXga6B666I9OGsoRsPtMbCa7l2q6OVaAs6uMxpejXDdd+SPSTMP+vyGdri6+bAQui8u8BmaIbwxUdcXkg0dNRTjOf6BNiSOGirrXYxjcXQ+632ag6EPE7kMiU/h4dA1FJfhgUnTzZTRkCOEt8apYcpj+P1E6u4+j+H3E+kCdUmKxZAjkS4QrbMY8nwKC7qGYjFkSaQL9rqGw5AthORhIoMhUyJ9ksPwsDI+Brv97xtWY8mJNUwZYtixYu0qyjhd+yYwDALD7MAwCAyzA8MgMMwODIPAMDtHGxZ1JYvjDRvWajCC7SYRfhsBhvKBIQzlA0MYygeGMJQPDGEoHxjCUD4whKF8YAhD+cAQhvKBIQzlA0MYygeGMJQPDGEoHxjCUD4whKF8YAhD+cAQhvJJM/wpEgyv9U+R8iNaAAAAAAAAAAAAAAAAAP4r/gEYCYE2Xwz6DQAAAABJRU5ErkJggg=='

const [catid, setcatid] = useState('')
const [allsubcategorycollection, setallsubcategorycollection] = useState([])

const [Filt, setFilt] = useState('')
const [currentpage, setcurrentpage] = useState(1)
const [postperpage, setpostperpage] = useState(50)
const [categname, setcategname] = useState('All Categories')
const [productfilters, setproductfilters] = useState([])
const [allbrandwise, setallbrandwise] = useState([])
const [brandname, setbrandname] = useState('All Brand')
const [allbrandwisefilter, setallbrandwisefilter] = useState([])
const [subcategorys, setsubcategorys] = useState('')
const [productcategory, setproductcategory] = useState(localStorage.getItem('SBrandcategory'))
  const onUpdate = (render, handle, value) => {
    setProductList(allproductslists.filter(
      product => product.newPrice >= value[0] && product.newPrice <= value[1]
    ));
  };

  /*
  on change rating checkbox method
  */
  const onChangeRating = value => {
  
    setProductList(productsData.filter(product => product.rating >= value));
  };

  const onSelectRating = value => {
    setProductList(productsData.filter(product => product.rating === value));
  };

  const onUncheckMark = () => {
    setProductList(productsData);
  };

  const handlePageClick = page => {
    setcurrentpage(page);
  };
  const toggle = (id,) =>{
  
    setIsOpen(!isOpen);
    Getallproductsubcategory(id)
    
  }
  

  useEffect(() => {
    Getallproductmaincategory()
    if(localStorage.getItem('Sbrndid')=== 'All'){
      Getallproductslistsss()
    }else {
      Getonebrandwise(localStorage.getItem('Sbrndid'),localStorage.getItem('SBrandcategory'))
    }
   
  
    Getallproductmaincategory()
   // Getallproductslistsss()
   Getallbrandwise()
   getpotodaycollections()
   getsocollectiontoday()
   getpomonthcollection()
   getsomonthcollection()
   getmonthwisepurchaseinvoice()
   getmonthisesalesinvoice()
  }, [])
  const getpotodaycollections = async() => {
    const Getcom =  await axios.instance.get(`/gettodaypo/${localStorage.getItem('CompanyId')}`,  { headers: {'Authorization':tokent,
    'Content-Type': 'application/json',
    
    }}).then((res) => {
      ////////console.log(res.data)
      setpotodaycollection(res.data)
      let todaypo = []
      todaypo.push(res.data[0])
      for (const Data of todaypo) {
        ////////////console.log(Data)
         // setCompnayid( Data.Company_Id)
        localStorage.setItem('todaypo', Data.todaypurchase)
      
      }
    })
  }

  const getsocollectiontoday = async() => {
    const Getcom =  await axios.instance.get(`/gettodayso/${localStorage.getItem('CompanyId')}`,  { headers: {'Authorization':tokent,
    'Content-Type': 'application/json',
    
    }}).then((res) => {
      ////////console.log(res.data)
      setsotodaycollection(res.data)
      let todayso = []
      todayso.push(res.data[0])
      for (const Data of todayso) {
        ////////////console.log(Data)
         // setCompnayid( Data.Company_Id)
        localStorage.setItem('todayso', Data.todaysales)
      
      }
    })
  }


  const getpomonthcollection= async() => {
    const Getcom =  await axios.instance.get(`/Getmonthwisepo/${localStorage.getItem('CompanyId')}`,  { headers: {'Authorization':tokent,
    'Content-Type': 'application/json',
    
    }}).then((res) => {
      ////////console.log(res.data)
      setpomonthcollection(res.data)
      let monthwisepo = []
      monthwisepo.push(res.data[0])
      for (const Data of monthwisepo) {
        ////////////console.log(Data)
         // setCompnayid( Data.Company_Id)
        localStorage.setItem('monthwisepo', Data.monthlypurchase)
      
      }
    })
  }


  const getsomonthcollection= async() => {
    const Getcom =  await axios.instance.get(`/getmonthwiseso/${localStorage.getItem('CompanyId')}`,  { headers: {'Authorization':tokent,
    'Content-Type': 'application/json',
    
    }}).then((res) => {
      ////////console.log(res.data)
      setsomonthcollection(res.data)
      let monthwiseso = []
      monthwiseso.push(res.data[0])
      for (const Data of monthwiseso) {
        ////////////console.log(Data)
         // setCompnayid( Data.Company_Id)
        localStorage.setItem('monthwiseso', Data.mothlysales)
      
      }
    })
  }



  const getmonthwisepurchaseinvoice= async() => {
    const Getcom =  await axios.instance.get(`/DashPurchase/${localStorage.getItem('CompanyId')}`,  { headers: {'Authorization':tokent,
    'Content-Type': 'application/json',
    
    }}).then((res) => {
      ////////console.log(res.data)
      setpurchaseinvoicecollections(res.data)
      let purchseinvoice = []
      purchseinvoice.push(res.data[0])
      for (const Data of purchseinvoice) {
        ////////////console.log(Data)
         // setCompnayid( Data.Company_Id)
        localStorage.setItem('todaypurchseinvoice', Data.CurPurchase)
        localStorage.setItem('monthpurchseinvoice', Data.AsOnPurchase)
      
      }
    })
  }

  const getmonthisesalesinvoice= async() => {
    const Getcom =  await axios.instance.get(`/DashSales/${localStorage.getItem('CompanyId')}`,  { headers: {'Authorization':tokent,
    'Content-Type': 'application/json',
    
    }}).then((res) => {
      ////////console.log(res.data)
      setsalesinvoicecollections(res.data)
      let salesinvoice = []
      salesinvoice.push(res.data[0])
      for (const Data of salesinvoice) {
        ////////////console.log(Data)
         // setCompnayid( Data.Company_Id)
        localStorage.setItem('todaysalesinvoice', Data.Cursales)
        localStorage.setItem('monthsalesinvoice', Data.AsOnSales)
      
      }
    })
  }

  const Getallproductmaincategory = async() => {
    const get= await axios.instance.get('/Getallproductmaincategory',{ headers: {'Authorization':tokent,
    'Content-Type': 'application/json',
    
    }}).then((res) => {
      let datas=res.data[7]
  //     for(const data of res.data[7]) {

  //  datas.push(data)
  //     }
    //////////////console.log(datas)
  setproductmaincategory(res.data)
 //////////////console.log(res.data[7])
    })
    }

    const Getallproductslistsss = async() => {
      const get= await axios.instance.get('/Getallproducts',{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
      
      }}).then((res) => {
    setallproductslists(res.data)
    setproductfilters(res.data)
    setcategname('All Categoires')
    setsubcategorys('')
   // localStorage.setItem('SBrandcategory','All Categoires')
    //localStorage.setItem('Sbrndid','All')
      })
      }
      const Getallproductsubcategory = async(id,) => {
        const get= await axios.instance.get(`/Getallsubcategory/${id}`,{ headers: {'Authorization':tokent,
        'Content-Type': 'application/json',
        
        }}).then((res) => {
      setallsubcategorycollection(res.data)
  
        })
        }


        const Getallbrandwise = async() => {
          const get= await axios.instance.get(`/GetallBrand`,{ headers: {'Authorization':tokent,
          'Content-Type': 'application/json',
          
          }}).then((res) => {
           
        //     for(const data of res.data[7]) {
      
        //  datas.push(data)
        //     }
          //////////////console.log(datas)
        setallbrandwise(res.data)
        //////////console.log('brand',res.data)
       setcategname('All Categoires')
      //  setproductfilters(res.data)
        setsubcategorys('')
       //////////////console.log(res.data[7])
          })
          }

          const Getonebrandwise = async(id,id1) => {
            const get= await axios.instance.get(`/Getonebrandfilter/${id}`,{ headers: {'Authorization':tokent,
            'Content-Type': 'application/json',
            
            }}).then((res) => {
      
          setallbrandwisefilter(res.data)
          //////////console.log('brand',res.data)
     setproductfilters(res.data)
     setcategname(id1)
     localStorage.setItem('Sbrndid',id)
     localStorage.setItem('SBrandcategory',id1)
     setsubcategorys('')
            })
            }

        // let ProductArray =  allproductslists.filter(item => {
        //   return  Object.keys(item).some(key => 
        //     item[key].toString().toLowerCase().includes(Filt)
        //   )
        //     })
        let indexoflastpost = currentpage * postperpage
        let indexoffistpost = indexoflastpost-postperpage
        let ProductArray =  productfilters.filter(item => {
          return  Object.keys(item).some(key => 
            item[key].toString().toLowerCase().includes(Filt)
          )
            })
         
          let Pagenumbers = []
          for (let i = 1; i <= Math.ceil(productfilters.length / postperpage); i++){
            Pagenumbers.push(i)
         
          }
          let Curretpage = productfilters.slice(indexoffistpost,indexoflastpost)
          const  keys=['Product_Details_Description','Brand','Sales_Rate']
          const Data = (data) => {
            setFilt(data)
        
        
          let ProductArray =  allproductslists.filter(item => {
            return keys.some(key => 
               item[key].toString().toLowerCase().includes(data.toLowerCase())
             )
               })
               ////////////console.log(ProductArray)
              setproductfilters(ProductArray)
              setcurrentpage(1)
          }
          const Getallcatebyproduct = async(id,id1,id2) => {
            const get= await axios.instance.get(`/Getcategorybyproduct/${id}`,{ headers: {'Authorization':tokent,
            'Content-Type': 'application/json',
            
            }}).then((res) => {
          setallproductslists(res.data)
          setproductfilters(res.data)
         setcategname(id1)
         setsubcategorys(id2)
         toggle1()
            })
            }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {localStorage.getItem('salesedit')==='true' ? (
          <Breadcrumbs title="Edit Sales Order" breadcrumbItem="Product" />
          ): <Breadcrumbs title="Sales Order" breadcrumbItem="Product" />
       
       
       }
          <Row>
            <Col lg="4" xl="3">
              <Card>
                <CardHeader className="bg-transparent border-bottom">
                  <h5 className="mb-0">Filters</h5>
                </CardHeader>
              
            
 
                   
                   
                 <div className="p-4">
                <h5 className=" mb-3"  style={{cursor:"pointer",}} onClick={Getallproductslistsss}  >  Brand  <i className="fas fa-angle-down font-size-15 text-end" style={{marginLeft:"138px"}} onClick={toggle12}></i></h5>

                <Collapse isOpen={Isopen12} onClick={toggle12}>
                {/* <h5 className="font-size-14 mb-3"  style={{cursor:"pointer"}} onClick={Getallbrandwise}  >All Brand</h5> */}
                 {allbrandwise.map((data,index) => (
                  <div className="custom-accordion"  key={index}> 
              
      

                
                    <Link to="#"className="text-body fw-semibold pb-2 d-block"  onClick={()=>Getonebrandwise(data.Brand_Id,data.Brand)} >  <i className="mdi mdi-circle-medium me-1"></i> {data.Brand} 
                    {allsubcategorycollection.length !=0 ?  allsubcategorycollection.map((data1) => (

                  
                    <Collapse  key={data.Category_Id} isOpen={data1.MainCategory_Id === data.MainCategory_Id }>
                      <div className="shadow-none">
                        <ul  className="list-unstyled categories-list mb-0">
                        

                         
                         
                         </ul>
                      </div>
                     </Collapse> 
                      )): null}  
                     </Link> 
                  
              
                  </div>
                  ))}
                   </Collapse>
                </div> 
                <div className="p-4">
                  {/* <h5 className="font-size-14 mb-3">Main Categories</h5> */}
                  <h5 className="mb-3"  style={{cursor:"pointer",marginTop:"-40px"}} onClick={Getallproductslistsss}  >  Categories  <i className="fas fa-angle-down font-size-15 text-end" style={{marginLeft:"100px"}} onClick={toggle1} ></i></h5>

                  <Collapse isOpen={isopen1} >

                  <div className="custom-accordion">

                  {/* <h5 className="font-size-14 mb-3" style={{cursor:"pointer",}}  >All Categories</h5> */}
        {productmaincategory.map((data) => (

                
                    <Link to="#" key={data.MainCategory_Id} className="text-body fw-semibold pb-2 d-block" onClick={() => toggle(data.MainCategory_Id,data.MainCategory_Description)}>  {data.MainCategory_Description} <i  className="mdi mdi-chevron-down accor-up-icon text-primary me-1"></i>
                     {allsubcategorycollection.length !=0 ?  allsubcategorycollection.map((data1) => (

                  
                    <Collapse  key={data.Category_Id} isOpen={data1.MainCategory_Id === data.MainCategory_Id }>
                      <div className="shadow-none">
                        <ul  className="list-unstyled categories-list mb-0">
                          <li ><Link onClick={() =>Getallcatebyproduct(data1.Category_Id,data1.MainCategory_Description,data1.Category_Description)}  to="#"><i className="mdi mdi-circle-medium me-1"></i> {data1.Category_Description}</Link></li>
                         
                          {/* <li><Link to="#"><i className="mdi mdi-circle-medium me-1"></i> Casual Shoes</Link></li>
                          <li><Link to="#"><i className="mdi mdi-circle-medium me-1"></i> Sandals</Link></li>
                          <li><Link to="#"><i className="mdi mdi-circle-medium me-1"></i> Slippers</Link></li> */}
                        </ul>
                      </div>
                    </Collapse>
                       )): null}
                    </Link>
                      ))}
                
                  </div>
                  </Collapse>
                </div>
                {/* <div className="p-4 border-top">
                  <div>
                    <h5 className="font-size-14 mb-4">Price</h5>
                    <br />
                    <Nouislider
                      range={{ min: 0, max: 1600 }}
                      tooltips={true}
                      start={[100, 1500]}
                      connect
                      onSlide={onUpdate}
                    />
                  </div>
                </div> */}
              
              </Card>
            </Col>

            <Col lg="8" xl="9">
              <Card>
                <CardBody>
                  <div>
                    <Row>
                    <Col md="6">
                        <div>
                          <h5>Showing result for {productcategory} <i className="fas fa-arrow-right font-size-13 "></i>  {subcategorys}</h5>
                          {/* <ol className="breadcrumb p-0 bg-transparent mb-2">
                            <li className="breadcrumb-item"><Link to="#">Footwear</Link></li>
                            <li className="breadcrumb-item active">Shoes</li>
                          </ol> */}
                        </div>
                      </Col>

                      <Col md="6">
                        <div className="form-inline float-md-end">
                          <div className="search-box ml-2">
                            <div className="position-relative">
                              <Input
                                type="text"
                                className="orm-control bg-light border-light rounded"
                                placeholder="Search..."
                                value={Filt}
                                onChange={(e)=> Data(e.target.value)}
                              />
                              <i className="mdi mdi-magnify search-icon"></i>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                   
                    <Row>
                      {!isEmpty(Curretpage) &&
                        Curretpage.map((data) => (
                          <Col xl="4" sm="6" key={data.Product_Details_Id}>
                            <div className="product-box" onClick={() =>
                              history.push(`/Sales-order-detail/${data.Product_Details_Id}`)
                            }>
                          <div className="product-img pt-2 px-2 hover14 column">
                            
                              
                                           
                            <figure>
   <img src={`${data.Imagepath}`} 
    style={{width:'200px', height:'200px',}}
     alt="" className="img-fluid mx-auto d-block "
     onError={({ currentTarget }) => {
       currentTarget.onerror = null; // prevents looping
       currentTarget.src=imageDefault;
     }}
      
     /> 
    </figure>
                                 </div>

                              <div className="text-center  p-4">
                              <h6 className="mb-1">{data.Brand} </h6>
                              <h6 className="mb-1">  {data.Product_Details_Description}{" "}
                                
                              
                               
                                </h6>
                                <h5 className="mb-1">  ₹  {numeral(data.Sales_Rate).format('0,0.00')}{" "}
                                
                               
                            </h5>
                              

                              </div>
                            </div>
                          </Col>
                        ))}
                    </Row>
                    <Row className="justify-content-md-end justify-content-center align-items-center">
        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button
              color="primary"
           disabled={currentpage === 1}
           onClick={() => handlePageClick(1)}
            >
              {"<<"}
            </Button>
            <Button
              color="primary"
              disabled={currentpage === 1}
              onClick={() => handlePageClick(currentpage - 1)}
            >
              {"<"}
            </Button>
          </div>
        </Col>
       
        <Col className="col-md-auto">
          <Input
            type="number"
            min={1}
            style={{ width: 70 }}
            value={currentpage}
            onChange={(e)=> setcurrentpage(e.target.value)}
          />
        </Col>

        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button color="primary"  disabled={Pagenumbers.length === currentpage}    onClick={() => handlePageClick(parseInt(currentpage) + 1)}>
              {">"}
            </Button>
            <Button
              color="primary"
              onClick={() => handlePageClick(Pagenumbers.length )}
              disabled={Pagenumbers.length === currentpage}
            >
              {">>"}
            </Button>
          </div>
        </Col>
      </Row>
                    {/* <Row className="mt-4">
                      <Col sm="6">
                        <div>
                          <p className="mb-sm-0">Page {currentpage} of  {Pagenumbers.length}</p>
                        </div>
                      </Col>
                      <Col sm="6">
                        <div className="float-sm-end">
                          <Pagination className="pagination pagination-rounded mb-sm-0">
                            <PaginationItem disabled={currentpage === 1}>
                              <PaginationLink
                                previous
                                to="#"
                                onClick={() => handlePageClick(currentpage - 1)}
                              />
                            </PaginationItem>
                            {map(Array(Pagenumbers.length), (item, i) => (
                              <PaginationItem active={i + 1 === currentpage} key={"_pagination_" + i}>
                                <PaginationLink
                                  onClick={() => handlePageClick(i + 1)}
                                  to="#"
                                >
                                  {i + 1}
                                </PaginationLink>
                              </PaginationItem>
                            ))}
                            <PaginationItem disabled={Pagenumbers.length === currentpage}>
                              <PaginationLink
                                next
                                to="#"
                                onClick={() => handlePageClick(currentpage + 1)}
                              />
                            </PaginationItem>
                          </Pagination>
                        </div>
                      </Col>
                    </Row> */}
                   
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {dailoa1 ? (
      <Backdrop  open={dailoa1} className={classes.backdrop} >
      <Spinner name="ball-spin-fade-loader"  color='#fafafa' />

     </Backdrop>
      ): null}
      {Purchasesavess ? (
                    <SweetAlert
                      title="Product  Added Successfully"
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      success
                      onConfirm={() => {
                        setPurchasesavess(false);
                      }}
                    ></SweetAlert>
                  ) : null}
    </React.Fragment>
  );
};

EcommerceProducts.propTypes = {
  products: PropTypes.array,
  history: PropTypes.object,
  onGetProducts: PropTypes.func,
}

export default withRouter(EcommerceProducts)
